
import { defineComponent, ref, PropType } from 'vue';
import OverlayModal from '@/components/Calendar/OverlayModal.vue';
import { IdName } from '@/models/Interfaces';

export default defineComponent({
    props: {
        tags: {
            type: Array as PropType<IdName[]>,
            required: true
        }
    },
    components: { OverlayModal },
    name: 'TagsManagementModal',
    async setup(props, { emit }) {
        const isOpen = ref(false);
        const editingTag = ref<IdName | null>(null);
        const newTagName = ref('');
        const editTag = (tag: IdName) => {
            editingTag.value = JSON.parse(JSON.stringify(tag));
        };
        function open() {
            isOpen.value = true;
        }
        function close() {
            isOpen.value = false;
        }
        async function saveTag(isNewTag: boolean) {
            const tag: IdName = {
                id: isNewTag ? '' : editingTag.value!.id,
                name: isNewTag ? newTagName.value : editingTag.value!.name
            };
            emit('onSave', tag);
        }
        async function onDelete(tagId: string) {
            emit('onDelete', tagId);
        }
        const submitForm = async (event: any) => {
            event.target.classList.add('was-validated');
            if (event.target.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                return;
            } else {
                await saveTag(true);
                event.target.classList.remove('was-validated');
            }
        };

        return { open, close, editTag, saveTag, submitForm, newTagName, isOpen, editingTag, onDelete };
    }
});
